export const mutations = {
  SET_GLOBALS: (state, payload) => {
    state.globals = payload
  },
}
